import Logger from "../../../../core/internal/logger"
import { DecisionReason } from "../../../../core/internal/model/model"
import { InAppMessageImpression, InAppMessageImpressionStorage } from "../../storage/InAppMessageImpressionStorage"
import { InAppMessagePresentRequest } from "../InAppMessagePresentRequest"
import { InAppMessagePresentResponse } from "../InAppMessagePresentResponse"

export class InAppMessageRecorder {
  private readonly STORE_MAX_SIZE = 100
  constructor(private readonly storage: InAppMessageImpressionStorage) {}

  record(request: InAppMessagePresentRequest, response: InAppMessagePresentResponse) {
    if (request.reason === DecisionReason.OVERRIDDEN) {
      return
    }

    try {
      this.doRecord(request)
    } catch (e) {
      Logger.log.error(`Failed to record InAppMessageImpression: ${e}`)
    }
  }

  private doRecord(request: InAppMessagePresentRequest) {
    const impressions = this.storage.get(request.inAppMessage)
    const impression: InAppMessageImpression = {
      identifiers: request.user.identifiers,
      timestamp: request.requestedAt
    }

    const newImpressions = [...impressions, impression]
    const victimCriteriaIndex =
      newImpressions.length > this.STORE_MAX_SIZE ? newImpressions.length - this.STORE_MAX_SIZE : 0
    const impressionToSave = newImpressions.slice(victimCriteriaIndex)

    this.storage.set(request.inAppMessage, impressionToSave)
  }
}
